import AxiosInitializer from 'api/Utility/AxiosInitializer'
import apiWrapper from 'api/Utility/ApiWrapper'
import getToken from 'lib/authentication/GetToken'
import { getBaseURL } from 'lib/utility/GetBaseUrl'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const HeartbeatURL = `${getBaseURL()}/admin/api/auth/heartbeat`

const heartbeatEndPoint = {
  getUnexpectedVisitCookie: () => {
    return axiosRequest().patch(HeartbeatURL, {}, { withCredentials: true })
  },
}

const heartbeatAPI = {
  getUnexpectedVisitCookie: (params = {}) =>
    apiWrapper({
      endPoint: heartbeatEndPoint.getUnexpectedVisitCookie,
      params,
    }),
}

export default heartbeatAPI
